import BaseModel from "@kaspernj/api-maker/build/base-model.js"
import modelClassRequire from "@kaspernj/api-maker/build/model-class-require.js"

const modelClassData = {
  "attributes": {
    "created_at": {
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      },
      "name": "created_at",
      "selected_by_default": null,
      "translated": null
    },
    "id": {
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": null
      },
      "name": "id",
      "selected_by_default": null,
      "translated": null
    },
    "score_factor_group_id": {
      "column": {
        "default": null,
        "name": "score_factor_group_id",
        "null": false,
        "type": null
      },
      "name": "score_factor_group_id",
      "selected_by_default": null,
      "translated": null
    },
    "score_factor_id": {
      "column": {
        "default": null,
        "name": "score_factor_id",
        "null": false,
        "type": null
      },
      "name": "score_factor_id",
      "selected_by_default": null,
      "translated": null
    },
    "updated_at": {
      "column": {
        "default": null,
        "name": "updated_at",
        "null": false,
        "type": "datetime"
      },
      "name": "updated_at",
      "selected_by_default": null,
      "translated": null
    }
  },
  "className": "ScoreFactorGroupScoreFactor",
  "collectionKey": "score_factor_group_score_factors",
  "collectionName": "score_factor_group_score_factors",
  "i18nKey": "score_factor_group_score_factor",
  "camelizedLower": "scoreFactorGroupScoreFactor",
  "name": "ScoreFactorGroupScoreFactor",
  "nameDasherized": "score-factor-group-score-factor",
  "pluralName": "score_factor_group_score_factors",
  "ransackable_associations": [
    {
      "className": "ScoreFactorGroupScoreFactor::Audit",
      "collectionName": "score_factor_group_score_factor_audits",
      "foreignKey": "score_factor_group_score_factor_id",
      "name": "audits",
      "macro": "has_many",
      "resource_name": "ScoreFactorGroupScoreFactorAudit",
      "through": null
    },
    {
      "className": "ScoreFactorGroupScoreFactor::Audit",
      "collectionName": "score_factor_group_score_factor_audits",
      "foreignKey": "score_factor_group_score_factor_id",
      "name": "create_audit",
      "macro": "has_one",
      "resource_name": "ScoreFactorGroupScoreFactorAudit",
      "through": null
    },
    {
      "className": "ScoreFactor",
      "collectionName": "score_factors",
      "foreignKey": "score_factor_id",
      "name": "score_factor",
      "macro": "belongs_to",
      "resource_name": "ScoreFactor",
      "through": null
    },
    {
      "className": "ScoreFactorGroup",
      "collectionName": "score_factor_groups",
      "foreignKey": "score_factor_group_id",
      "name": "score_factor_group",
      "macro": "belongs_to",
      "resource_name": "ScoreFactorGroup",
      "through": null
    }
  ],
  "ransackable_attributes": [
    {
      "name": "created_at",
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      }
    },
    {
      "name": "id",
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": null
      }
    },
    {
      "name": "score_factor_group_id",
      "column": {
        "default": null,
        "name": "score_factor_group_id",
        "null": false,
        "type": null
      }
    },
    {
      "name": "score_factor_id",
      "column": {
        "default": null,
        "name": "score_factor_id",
        "null": false,
        "type": null
      }
    },
    {
      "name": "updated_at",
      "column": {
        "default": null,
        "name": "updated_at",
        "null": false,
        "type": "datetime"
      }
    }
  ],
  "ransackable_scopes": [],
  "relationships": [
    {
      "className": "ScoreFactor",
      "collectionName": "score_factors",
      "foreignKey": "score_factor_id",
      "name": "score_factor",
      "macro": "belongs_to",
      "resource_name": "ScoreFactor",
      "through": null
    },
    {
      "className": "ScoreFactorGroup",
      "collectionName": "score_factor_groups",
      "foreignKey": "score_factor_group_id",
      "name": "score_factor_group",
      "macro": "belongs_to",
      "resource_name": "ScoreFactorGroup",
      "through": null
    }
  ],
  "paramKey": "score_factor_group_score_factor",
  "primaryKey": "id"
}

/** Frontend model for ScoreFactorGroupScoreFactor. */
class ScoreFactorGroupScoreFactor extends BaseModel {
  /** @returns {Record<string, any>} */
  static modelClassData() {
    return modelClassData
  }

  /** @returns {string} */
  createdAt() {
    return this.readAttributeUnderscore("created_at")
  }

  /** @returns {boolean} */
  hasCreatedAt() {
    const value = this.createdAt()

    return this._isPresent(value)
  }

  /** @returns {any} */
  id() {
    return this.readAttributeUnderscore("id")
  }

  /** @returns {boolean} */
  hasId() {
    const value = this.id()

    return this._isPresent(value)
  }

  /** @returns {any} */
  scoreFactorGroupId() {
    return this.readAttributeUnderscore("score_factor_group_id")
  }

  /** @returns {boolean} */
  hasScoreFactorGroupId() {
    const value = this.scoreFactorGroupId()

    return this._isPresent(value)
  }

  /** @returns {any} */
  scoreFactorId() {
    return this.readAttributeUnderscore("score_factor_id")
  }

  /** @returns {boolean} */
  hasScoreFactorId() {
    const value = this.scoreFactorId()

    return this._isPresent(value)
  }

  /** @returns {string} */
  updatedAt() {
    return this.readAttributeUnderscore("updated_at")
  }

  /** @returns {boolean} */
  hasUpdatedAt() {
    const value = this.updatedAt()

    return this._isPresent(value)
  }

  /** @returns {import("./score-factor.js").default | null} */
  scoreFactor() {
    return this._readBelongsToReflection({reflectionName: "score_factor"})
  }

  /** @returns {Promise<import("./score-factor.js").default | null>} */
  loadScoreFactor() {
    if (!("scoreFactorId" in this)) throw new Error("Foreign key method wasn't defined: scoreFactorId")

    const id = this.scoreFactorId()
    const modelClass = modelClassRequire("ScoreFactor")
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {reflectionName: "score_factor", model: this, modelClass},
      {ransack}
    )
  }

  /** @returns {import("./score-factor-group.js").default | null} */
  scoreFactorGroup() {
    return this._readBelongsToReflection({reflectionName: "score_factor_group"})
  }

  /** @returns {Promise<import("./score-factor-group.js").default | null>} */
  loadScoreFactorGroup() {
    if (!("scoreFactorGroupId" in this)) throw new Error("Foreign key method wasn't defined: scoreFactorGroupId")

    const id = this.scoreFactorGroupId()
    const modelClass = modelClassRequire("ScoreFactorGroup")
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {reflectionName: "score_factor_group", model: this, modelClass},
      {ransack}
    )
  }
}

export default ScoreFactorGroupScoreFactor
